import { axios } from '@/utils/request'


/**
 * 查询列表
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function noticeQuery (parameter) {
  return axios({
    url: '/baNotice/getAllNotice',
    method: 'get',
    params: parameter
  })
}

/**
 * 修改轮播图
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function nuticeEdit (parameter) {
  return axios({
    url: '/baNotice/updateNotice',
    method: 'post',
    data: parameter
  })
}



/**
 * 删除
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function pictureDelete (parameter) {
  return axios({
    url: '/baCarousel/updateCarousel',
    method: 'post',
    data: parameter
  })
}


/**
 * 发布
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function nuticeRelease (parameter) {
  return axios({
    url: '/baNotice/publishNotice',
    method: 'get',
    params: parameter
  })
}



/**
 * 添加  
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function noticeAdd (parameter) {
  return axios({
    url: '/baNotice/insertNotice',
    method: 'post',
    data: parameter
  })
}




/**
 * 上传图片
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function noticeUpdate (parameter) {
  return axios({
    url: '/baNotice/cos/upload',
    method: 'post',
    data: parameter
  })
}
